module.exports = __webpack_public_path__ + "static/media/profile.55e9620b.jpg";